import { ReactElement } from 'react';

import CTA from 'components/UI/Cta';
import { IComponentServicesGalleryFields } from 'types/contentful';
import Carousel from 'components/UI/Carousel';

export default function ServicesGallery({
  heading,
  gallery,
  cta,
}: IComponentServicesGalleryFields): ReactElement {
  const galleryItems = gallery.map((block) => block.fields);

  const items = galleryItems.map((service, index) => {
    const url = service.image?.fields.file.url ?? '/images/preview-placeholder.jpeg';
    return (
      <a href={service.link} key={index} className="service-item flex flex-col text-left">
        <div
          style={{ backgroundImage: `url(${url})` }}
          className="bg-cover bg-center aspect-ratio-services"
        ></div>
        <div className="flex justify-between items-center h-full bg-neutral-alt pl-4 pr-2 py-2">
          <span className="text-lg">{service.rowOneText ?? service.id}</span>
          <div className="block">
            <img src="/images/chevron-right.svg" alt="chevron right" className="w-7 h-7" />
          </div>
        </div>
      </a>
    );
  });

  return (
    <div className="ecp-my w-full px-site-component mx-auto pb-10 md:pb-20">
      <div className="text-new-34 md:text-4xl text-center mb-6 md:mb-12 text-secondary">
        {heading}
      </div>
      <div className="hidden md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">{items}</div>
      <div className="md:hidden">
        <Carousel items={items ?? []} title={''} className="carousel-services" />
      </div>
      <div className="w-full sm:w-2/5 mx-auto text-center mt-16 lg:mt-20">
        {cta?.fields && <CTA {...cta?.fields} classNames="button-text text-primary-actual" />}
      </div>
    </div>
  );
}
